import React from 'react';
import { connect } from 'react-redux';

import { Table, Button, TableRow, TableBody, TableHead, TableCell, TextField } from '@mui/material';

import TblIcon from '@mui/icons-material/List';
import LinkIcon from '@mui/icons-material/Link';
import FrmIcon from '@mui/icons-material/ViewCompact';

import ArrowRightIcon from '@mui/icons-material/ChevronRight';
import ArrowLeftIcon from '@mui/icons-material/ChevronLeft';

import TrplSelect from '../../../../../common/TrplControls/TrplSelect';

import { trplFormEditColumnWidthes, trplFormEditColumnHeights } from '../../../../../constants';

export default connect((state) => {
  return { jels: state.jels };
})(
  ({
    jels,
    group,
    classes,
    rowIndex,
    groupIndex,
    deleteGroup,
    groupsLength,
    toggleRstEditModal,
    onGroupFieldChange,
    changeGroupPosition,
    onGroupSizeSelectChange,
  }) => {
    return (
      <div className={classes.p10}>
        <div
          className={`${classes.column} ${classes.mb10}`}
        >
          <strong style={{ color: '#c4c4c4' }}>List</strong>
          <div className={`${classes.spaceBetween} ${classes.mb10}`}>
            <TextField
              style={{
                width: 'calc(100% - 80px)',
              }}
              label="Title"
              placeholder="Title"
              value={group.title}
              className={classes.mr10}
              onChange={(e) => onGroupFieldChange(rowIndex, groupIndex, 'title', e.target.value)}
            />

            <div className={classes.alignCenter}>
              <div className={classes.mr10}>
                <TrplSelect
                  title="Width"
                  margin="none"
                  complicatedValues
                  value={group.width || 'auto'}
                  values={trplFormEditColumnWidthes}
                  onChange={(e) => {
                    onGroupSizeSelectChange(rowIndex, groupIndex, 'width', e.target.value);
                  }}
                />
              </div>

              <TrplSelect
                title="Height"
                margin="none"
                complicatedValues
                value={group.height || '50vh'}
                values={trplFormEditColumnHeights}
                onChange={(e) => {
                  onGroupSizeSelectChange(rowIndex, groupIndex, 'height', e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        {group.links ? (
          <div>
            <Table className={classes.mb10} style={{ tableLayout: 'fixed' }}>
              <TableHead>
                <TableRow style={{ height: 'auto' }}>
                  <TableCell style={{ padding: '5px 2px' }}>Title</TableCell>
                  <TableCell style={{ padding: '5px 2px' }}>Url</TableCell>
                  <TableCell style={{ padding: '5px 2px' }}>Table / Form</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {group.links.map((link, linkIndex) => {
                  const linkJelData = link.jel ? jels.jelData[link.jel] : {};

                  const linkTitle = link.title || (linkJelData && linkJelData.title) || link.url;

                  const isTblOrFrm =
                    link.jel && linkJelData && linkJelData.type === 'table' ? (
                      <TblIcon className={classes.mr10} />
                    ) : link.jel && linkJelData && linkJelData.type === 'form' ? (
                      <FrmIcon className={classes.mr10} />
                    ) : (
                      <LinkIcon className={classes.mr10} />
                    );

                  return (
                    <TableRow key={linkIndex} style={{ height: 'auto' }}>
                      <TableCell style={{ width: '100px', padding: '5px 2px' }}>
                        <div className={classes.alignCenter}>
                          {isTblOrFrm} {linkTitle}
                        </div>
                      </TableCell>

                      <TableCell className={classes.linkCell} style={{ padding: '5px 2px' }}>
                        <span className={classes.linkUrl}>{link.url}</span>
                      </TableCell>
                      <TableCell style={{ padding: '5px 2px' }}>{linkJelData ? linkJelData.title : ''}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        ) : null}

        <Button
          style={{
            alignSelf: 'flex-start',
          }}
          size="small"
          variant="contained"
          color="primary"
          onClick={() => {
            toggleRstEditModal(rowIndex, groupIndex, 'links', true);
          }}
        >
          Edit
        </Button>
        <div className={classes.justifyEnd}>
          {groupIndex !== 0 ? (
            <ArrowLeftIcon
              className={`${classes.mr10} ${classes.pointer}`}
              onClick={() => {
                changeGroupPosition(rowIndex, groupIndex, groupIndex - 1);
              }}
            />
          ) : null}

          {groupIndex !== groupsLength ? (
            <ArrowRightIcon
              className={`${classes.mr10} ${classes.pointer}`}
              onClick={() => {
                changeGroupPosition(rowIndex, groupIndex, groupIndex + 1);
              }}
            />
          ) : null}

          <Button size="small" color="secondary" variant="contained" onClick={() => deleteGroup(rowIndex, groupIndex)}>
            Delete group
          </Button>
        </div>
      </div>
    );
  }
);
